import React from 'react';

import rider from 'assets/images/riders/rider.svg';

function InfoGraphic() {
  return (
    <div className="w-full flex justify-center mt-5">
      <img src={rider} alt="bg-logo" />
    </div>
  );
}
InfoGraphic.defaultProps = {};

InfoGraphic.propTypes = {};

export default InfoGraphic;
